import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './CategoryPrice.module.css';

const CategoryPrice = (props) => {
  const priceInput = useRef();

  const handleBlur = () => {
    // eslint-disable-next-line radix
    const hPrice = parseInt(priceInput.current.value);
    if (props.price === hPrice) {
      console.log('change price to submit!');
    } else {
      props.onPaywallChange(hPrice);
    }
  };

  const classes = styles.price;
  const { price } = props;
  return (
    <input
      type="number"
      min="0"
      step="0.01"
      ref={priceInput}
      defaultValue={price}
      className={classes}
      onBlur={handleBlur}
    />
  );
};

CategoryPrice.propTypes = {
  price: PropTypes.node.isRequired,
  onPaywallChange: PropTypes.node.isRequired,
};

export default CategoryPrice;
